import { ILogger } from '@tdp/common/telemetry';

export interface HeaderDataNetworkErrorResult {
  type: 'networkError';
  errorCode: number;
}

export interface HeaderDataSuccessResult {
  type: 'success';
  headerData: string;
}

export type HeaderDataResult =
  | HeaderDataSuccessResult
  | HeaderDataNetworkErrorResult;
export interface IHeaderDataProvider {
  getHeaderData: () => Promise<HeaderDataResult>;
}

export interface HeaderDataServiceDeps {
  logger: ILogger;
  apiFetch: typeof fetch;
}
export class HeaderDataService implements IHeaderDataProvider {
  private logger: ILogger;
  private apiFetch: typeof fetch;

  constructor(deps: HeaderDataServiceDeps) {
    this.apiFetch = deps.apiFetch;
    this.logger = deps.logger;
  }

  async getHeaderData(): Promise<HeaderDataResult> {
    const response = await this.apiFetch(
      '/topnavbar/culturename/en-us/currentmainlinkid/TeamsAppStudio'
    );
    if (response.status < 200 || response.status >= 300) {
      return {
        type: 'networkError',
        errorCode: response.status,
      };
    }
    const body = (await response.json()) as { NavBarDataJson: string }; //
    return {
      type: 'success',
      headerData: body.NavBarDataJson,
    };
  }
}
